import { buildModelManager } from "../builder.js";
const DefaultExtractionTemplateSelection = {
  __typename: true,
  id: true,
  accessLevel: true,
  cohort: true,
  createdAt: true,
  createdById: true,
  description: true,
  documentTypes: true,
  extractionFields: true,
  institution: true,
  isActive: true,
  isDefault: true,
  lastUsed: true,
  name: true,
  templateData: true,
  updatedAt: true,
  usageCount: true,
  version: true
};
const modelApiIdentifier = "extractionTemplate";
const pluralModelApiIdentifier = "extractionTemplates";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExtractionTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExtractionTemplateSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExtractionTemplateSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExtractionTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExtractionTemplateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExtractionTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExtractionTemplateSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createExtractionTemplate",
    operationReturnType: "CreateExtractionTemplate",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      extractionTemplate: { required: false, type: "CreateExtractionTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExtractionTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkCreateExtractionTemplates",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateExtractionTemplatesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExtractionTemplateSelection
  },
  {
    type: "action",
    operationName: "updateExtractionTemplate",
    operationReturnType: "UpdateExtractionTemplate",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      extractionTemplate: { required: false, type: "UpdateExtractionTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExtractionTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateExtractionTemplates",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateExtractionTemplatesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExtractionTemplateSelection
  },
  {
    type: "action",
    operationName: "deleteExtractionTemplate",
    operationReturnType: "DeleteExtractionTemplate",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteExtractionTemplates",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertExtractionTemplate",
    operationReturnType: "UpsertExtractionTemplate",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      extractionTemplate: { required: false, type: "UpsertExtractionTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateExtractionTemplateResult": { hasReturnType: false },
      "... on UpdateExtractionTemplateResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExtractionTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertExtractionTemplates",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertExtractionTemplatesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultExtractionTemplateSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "extractionTemplateGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ExtractionTemplateManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultExtractionTemplateSelection,
  operations
);
export {
  DefaultExtractionTemplateSelection,
  ExtractionTemplateManager
};
//# sourceMappingURL=ExtractionTemplate.js.map
